
import {
  getToken,
  setToken,
  removeToken,
  setUserInfo,
  getUserInfo
} from '@/utils/auth'
const state = {
  token: getToken(),
  userInfo: getUserInfo()
}
export default {
  state: {
    token: '',
    userInfo: state.userInfo
  },
  mutations: {
    // 存放token
    setToken (state, val) {
      state.token = val
      setToken(val)
    },
    setUser (state, val) {
      state.name = val
      setUserInfo(val)
    },
    getUser (state, val) {
      state.userInfo = getUserInfo(val)
    },
    // 清空token
    clearToken (state) {
      state.token = ''
      removeToken('')
    },
    // 获取token
    getToken (state) {
      state.token = state.token
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/user.js